// This file can be replaced during build by using the `fileReplacements` array.

// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.

// The list of file replacements can be found in `angular.json`.



export const environment = {

  production: true,

  googleMapsApi: 'AIzaSyCd-Uvdg1owNsF4W3PM8GDrzgPlQ-7qLRY',

  

  // Local backend for testing

  //apiServiceBaseUrl: 'http://localhost:8080/api/v1',

  // Production backend with custom domain

  apiServiceBaseUrl: 'https://som-water.com/api/v1',

  // Previous / local backends kept for reference:

  // apiServiceBaseUrl: 'http://localhost:8080/api/v1'

  // apiServiceBaseUrl: 'http://localhost:8081/api/v1'

  //apiServiceBaseUrl: 'http://ec2-204-236-203-130.compute-1.amazonaws.com:8080/api/v1'

  // apiServiceBaseUrl: 'http://ec2-54-152-116-130.compute-1.amazonaws.com:8080/api/v1'

};



